document.addEventListener("DOMContentLoaded", function() {
    const segmentsAssetsButton = document.querySelector('#main-block .open-pop-up-segments-assets');
    const segmentsAssetsPopUp = document.querySelector('#sectors-assets-pop-up');
    const segmentsAssetsBg = document.querySelector('#sectors-assets-pop-up .bg');
    const closeButton = document.querySelector('#close-sectors-popup');

    if (segmentsAssetsButton) {
        segmentsAssetsButton.addEventListener('click', () => {
            segmentsAssetsPopUp.classList.add('show');

            if (window.gtag) gtag('event', `Desktop_CenterPanel_SectorsClick`);
        });
    }
    segmentsAssetsBg.addEventListener('click', () => {
        segmentsAssetsPopUp.classList.remove('show');
    })
    
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            segmentsAssetsPopUp.classList.remove('show');
        });
    }
})
